import PropTypes from 'prop-types'

function WalletError({ walletType }) {
  return (
    <div className='walletErrorPopup'>
      <h3>No {walletType} wallet associated with user</h3>
      <p style={{ fontSize: '12px' }}>
        Please reload & contact admin if issue persists
      </p>
    </div>
  )
}

WalletError.propTypes = {
  walletType: PropTypes.string, // Ensure walletType is a required string
}

export default WalletError
